import createRoute   from '@widesk-ui/tools/createRoute';
import SitePageModel from '@models/website/SitePageModel';

const route = createRoute.dashboardFromModel(
	SitePageModel,
	'SitePageDashboard',
	{
		pathPrefix: '/website_entertainments/:websiteEntertainmentId',
	},
);
export default route;
